
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component<PuSlideoutPanel>({
  head() {
    return {
      bodyAttrs: {
        class: this.open ? 'noscroll' : '',
      },
    }
  },
})
export default class PuSlideoutPanel extends Vue {
  open = false
  loaded = false

  @Prop({ default: 'right' })
    position!: string

  @Prop({ default: false })
    showPanel!: boolean

  @Prop()
    triggerButtonClass!: string[]

  created() {
    this.loaded = true
  }

  openPanel() {
    this.open = true
  }

  closePanel() {
    this.open = false
  }

  closePanelByButton() {
    this.$emit('slideout-panel-closed-by-button')
    this.closePanel()
  }

  get panelPositionClass() {
    return this.open ? `${this.position} open` : this.position
  }

  @Watch('open')
  panelStateChanged(newValue: boolean) {
    this.$emit(newValue ? 'slideout-panel-opened' : 'slideout-panel-closed')
  }

  @Watch('showPanel')
  onShowPanelChanged(newValue: boolean): void {
    this.open = newValue
  }
}
